(function() {
  
  $('.navigation__dropdown > a').on('click', function() {
    expanded = $(this).parents('.navigation__dropdown').is('.navigation__dropdown--expanded')
    $('.navigation__dropdown').removeClass('navigation__dropdown--expanded')
    if (!expanded) {
      $(this).parents('.navigation__dropdown').addClass('navigation__dropdown--expanded')
    }
    return false
  })
  
  $(document).on('click', function() {
    if (!$(this).is('.navigation__dropdown > a')) {
      $('.navigation__dropdown').removeClass('navigation__dropdown--expanded')
    }
  })

  $('body').on('click', '.product-list__item', function(e) {
    if (e.target.classList.contains('add-to-cart')) {
      $(this).find('.add-to-cart').addClass('disabled').text('In Order')
      code = JSON.parse(e.target.dataset.code)
      up = {}
      up[code.id] = code.quantity
      $.ajax({
        method: 'post',
        url: '/cart/update.js',
        dataType: 'json',
        data: { updates: up },
        success: function(res) {
          if (res.item_count) {
            $('[data-relay-app="CartButtonApp"]').html('<a href="/cart" class="masthead__nav-item">Order: ' + Shopify.formatMoney(res.total_price) + '</a>')
          } else {
            $('[data-relay-app="CartButtonApp"]').html('<span class="masthead__nav-item masthead__nav-item--subdued">No orders</span>')
          }

          $('#react-right-toaster').html('<div class="toaster toaster--right toaster--success toaster--is-visible" style="text-align:center"><div class="toaster__content"><p><span class="toaster__checkmark"></span><span class="toaster__message" aria-live="off" tabindex="-1">Order updated</span></p></div></div></div>')
          setTimeout(function() {
           $('#react-right-toaster').html('')
          }, 3000)
        }
      })
      return false 
    } else {
      location.href = $(this).attr('data-href')
    }
  })
  
  document.querySelectorAll('.product-card--list-item').forEach(function(el) {
    el.addEventListener('click', function(e) {
      if (e.target.classList.contains('add-to-cart')) {
        $('[data-href="' + el.dataset.href + '"]').find('.add-to-cart').addClass('disabled').text('In Order')
        code = JSON.parse(e.target.dataset.code)
        up = {}
        up[code.id] = code.quantity
        $.ajax({
          method: 'post',
          url: '/cart/update.js',
          dataType: 'json',
          data: { updates: up },
          success: function(res) {
            if (res.item_count) {
              $('[data-relay-app="CartButtonApp"]').html('<a href="/cart" class="masthead__nav-item">Order: ' + Shopify.formatMoney(res.total_price) + '</a>')
            } else {
              $('[data-relay-app="CartButtonApp"]').html('<span class="masthead__nav-item masthead__nav-item--subdued">No orders</span>')
            }

            $('#react-right-toaster').html('<div class="toaster toaster--right toaster--success toaster--is-visible" style="text-align:center"><div class="toaster__content"><p><span class="toaster__checkmark"></span><span class="toaster__message" aria-live="off" tabindex="-1">Order updated</span></p></div></div></div>')
            setTimeout(function() {
             $('#react-right-toaster').html('')
            }, 3000)
          }
        })
       	return false 
      } else {
       	location.href = el.dataset.href 
      }
    })
  })

  if ($('.home-slider').length) {
    tns({
      container: '.home-slider .slider',
      autoplay: true,
      nav: false,
      autoplayButtonOutput: false
    });
  }

  if (typeof tns === 'function') {
    document.querySelectorAll('.featured-collection[data-featured-slider="true"]').forEach(function (root) {
      var ul = root.querySelector('ul.grid--view-items');
      if (!ul || !ul.children.length) return;

      var perRow = parseInt(root.getAttribute('data-slider-items'), 10);
      if (isNaN(perRow) || perRow < 1) perRow = 3;
      if (perRow > 5) perRow = 5;

      try {
        tns({
          container: ul,
          controls: true,
          nav: false,
          gutter: 16,
          items: Math.min(2, perRow),
          slideBy: 1,
          loop: true,
          rewind: false,
          responsive: {
            768: {
              items: perRow,
            },
          },
        });
      } catch (e) {
        if (typeof console !== 'undefined' && console.warn) {
          console.warn('Featured collection carousel:', e);
        }
      }
    });
  }

  $('.menu-mobile').on('click', function() {
    $('.masthead__nav').addClass('active')
    return false
  })

  $('.masthead__nav').on('click', function() {
    $('.masthead__nav').removeClass('active')
  })
  
})();


/* QC fix (Oct 2026): one add-to-order handler for every card, including carousel copies.
   Runs in the capture phase so the older per-card handlers only see non-button clicks (they open the product).
   Adds via /cart/add.js (never overwrites a free-pack line), refreshes the header cart and shows the toast. */
(function() {
  var CART_SVG = '<svg aria-hidden="true" focusable="false" class="svg-inline--fa fa-shopping-cart fa-w-18" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"></path></svg>';
  function money(c) { return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(c) : '$' + (c / 100).toFixed(2); }
  function refreshHeader(cart) {
    var html = cart.item_count
      ? '<a href="/cart" class="masthead__nav-item">' + CART_SVG + ' <span>' + money(cart.total_price) + '</span></a>'
      : '<span class="masthead__nav-item masthead__nav-item--subdued">No orders</span>';
    document.querySelectorAll('[data-relay-app="CartButtonApp"]').forEach(function(el) { el.innerHTML = html; });
  }
  function toast(msg, ok) {
    var box = document.getElementById('react-right-toaster');
    if (!box) { box = document.createElement('div'); box.id = 'react-right-toaster'; document.body.appendChild(box); }
    box.innerHTML = '<div class="toaster toaster--right ' + (ok ? 'toaster--success ' : '') + 'toaster--is-visible" style="text-align:center"><div class="toaster__content"><p>' + (ok ? '<span class="toaster__checkmark"></span>' : '') + '<span class="toaster__message" aria-live="polite">' + msg + '</span></p></div></div>';
    clearTimeout(box._t); box._t = setTimeout(function() { box.innerHTML = ''; }, 3000);
  }
  document.addEventListener('click', function(e) {
    var btn = e.target.closest && e.target.closest('.add-to-cart[data-code]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    if (btn.classList.contains('disabled') || btn._busy) return;
    var code; try { code = JSON.parse(btn.dataset.code); } catch (_) { return; }
    btn._busy = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: code.id, quantity: code.quantity }] }) })
      .then(function(r) { if (!r.ok) return r.json().then(function(j) { throw new Error(j.description || 'Could not add'); }); })
      .then(function() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r) { return r.json(); }); })
      .then(function(cart) {
        document.querySelectorAll('.add-to-cart[data-code]').forEach(function(b) {
          try { if (JSON.parse(b.dataset.code).id == code.id) { b.classList.add('disabled'); b.textContent = 'In Order'; } } catch (_) {}
        });
        refreshHeader(cart); toast('Order updated', true);
      })
      .catch(function(err) { toast(err.message || 'Could not add to order', false); })
      .then(function() { btn._busy = false; });
  }, true);
})();

/* QC fix (Oct 2026): the masthead is position:fixed, but .main only reserves a fixed gap, so on mobile
   (logo + search bar) the top of every page sat under the header. Reserve exactly the header's height. */
(function() {
  function fit() {
    var h = document.querySelector('.masthead'), m = document.getElementById('MainContent');
    if (!h || !m) return;
    if (getComputedStyle(h).position !== 'fixed') { m.style.marginTop = ''; return; }
    var need = h.getBoundingClientRect().bottom;   // includes the mobile search bar
    var cur = parseFloat(getComputedStyle(m).marginTop) || 0;
    if (Math.abs(cur - need) > 1) m.style.marginTop = need + 'px';
  }
  fit();
  window.addEventListener('load', fit);
  window.addEventListener('resize', fit);
  setTimeout(fit, 600);
})();
